import { Outlet } from 'react-router-dom';
import { MigrationSwitch } from '../components/MigrationSwitch';
import { LoadingFallback } from '../components/QueryResults/LoadingFallback';
import { PreLoginCard } from '../components/auth/PreLoginCard';
import { MSR3_HOME_FLAGS } from '../constant/featureFlags';
import DashboardLayout from '../layout/DashboardLayout';

/**
 * Pre-login card rather than MSR3BaseLayout: the session is gone, so the
 * workspace sidebar has nothing to navigate to and its queries have no token.
 */
export const LoggedOutElement = () => (
  <MigrationSwitch
    featureFlags={MSR3_HOME_FLAGS}
    loadingFallback={<LoadingFallback />}
    newComponent={
      <PreLoginCard>
        <Outlet />
      </PreLoginCard>
    }
    oldComponent={<DashboardLayout />}
  />
);
